export const FIRMHOUSE_VARIANT_TITLES = {
  regular: "Einmalzahlung",
  installments: "Monatliche Zahlung",
};

export const FIRMHOUSE_VARIANT_TITLE_ALIASES = {
  regular: ["Einmalzahlung", "One-time payment", "Regular"],
  installments: ["Monatliche Zahlung", "Monthly payment", "Installments"],
};

const SELLING_PLAN_MAPPING = {
  48: {
    subscription: "gid://shopify/SellingPlan/712516108662",
    subscriptionWithInstallments: "gid://shopify/SellingPlan/712508014966",
    oneTimeWithInstallments: "gid://shopify/SellingPlan/712508703094",
    installmentsCount: 2,
  },
  58: {
    subscription: "gid://shopify/SellingPlan/712516370806",
    subscriptionWithInstallments: "gid://shopify/SellingPlan/712508080502",
    oneTimeWithInstallments: "gid://shopify/SellingPlan/712508899702",
    installmentsCount: 2,
  },
  72: {
    subscription: "gid://shopify/SellingPlan/712516305270",
    subscriptionWithInstallments: "gid://shopify/SellingPlan/712507949430",
    oneTimeWithInstallments: "gid://shopify/SellingPlan/712508834166",
    installmentsCount: 3,
  },
  96: {
    subscription: "gid://shopify/SellingPlan/712516043126",
    subscriptionWithInstallments: "gid://shopify/SellingPlan/712507883894",
    oneTimeWithInstallments: "gid://shopify/SellingPlan/712508637558",
    installmentsCount: 3,
  },
  145: {
    subscription: "gid://shopify/SellingPlan/712516239734",
    subscriptionWithInstallments: "gid://shopify/SellingPlan/712507818358",
    oneTimeWithInstallments: "gid://shopify/SellingPlan/712508572022",
    installmentsCount: 5,
  },
  290: {
    subscription: "gid://shopify/SellingPlan/712516174198",
    subscriptionWithInstallments: "gid://shopify/SellingPlan/712507752822",
    oneTimeWithInstallments: "gid://shopify/SellingPlan/712508768630",
    installmentsCount: 10,
  },
};

const SUPPORTED_INTERVAL_DAYS = Object.keys(SELLING_PLAN_MAPPING)
  .map((value) => Number(value))
  .sort((a, b) => a - b);

const normalizeDays = (days) => {
  const numericDays = Number(days);

  if (Number.isNaN(numericDays)) {
    throw new Error(`Invalid Firmhouse interval days: ${days}`);
  }

  return SUPPORTED_INTERVAL_DAYS.reduce((closest, current) => {
    return Math.abs(current - numericDays) < Math.abs(closest - numericDays) ? current : closest;
  }, SUPPORTED_INTERVAL_DAYS[0]);
};

export const getSellingPlanMapping = (days) => {
  const normalizedDays = normalizeDays(days);
  const mapping = SELLING_PLAN_MAPPING[normalizedDays];

  if (!mapping) {
    throw new Error(`No Firmhouse selling plan mapping configured for ${days} days.`);
  }

  return mapping;
};

export const getNormalizedSellingPlanDays = (days) => normalizeDays(days);

export const getVariantType = ({ monthly }) => (monthly ? "installments" : "regular");

export const getVariantTitle = (variantType) => {
  const title = FIRMHOUSE_VARIANT_TITLES[variantType];

  if (!title) {
    throw new Error(`Unknown Firmhouse variant type: ${variantType}`);
  }

  return title;
};

export const getVariantTitleAliases = (variantType) => {
  const aliases = FIRMHOUSE_VARIANT_TITLE_ALIASES[variantType];

  if (!aliases) {
    throw new Error(`Unknown Firmhouse variant type: ${variantType}`);
  }

  return aliases;
};

export const getVariantMetafieldSellingPlanId = (days, variantType) => {
  const mapping = getSellingPlanMapping(days);

  return variantType === "installments" ? mapping.subscriptionWithInstallments : mapping.subscription;
};

export const getCartSellingPlanId = ({ days, monthly, reorder }) => {
  const mapping = getSellingPlanMapping(days);

  if (!monthly && !reorder) {
    return null;
  }

  if (monthly && !reorder) {
    return mapping.oneTimeWithInstallments;
  }

  if (monthly && reorder) {
    return mapping.subscriptionWithInstallments;
  }

  return mapping.subscription;
};

export const getInstallmentsCount = (days) => getSellingPlanMapping(days).installmentsCount;

export const toShopifyResourceId = (gid) => {
  if (!gid) {
    return null;
  }

  return gid.split("/").pop();
};
